import {Measure} from './Measure';
import {MeasureModeItem} from './MeasureModeItem';

export class MeasureMode {
code: string;
computeRev: number | null;
crossedDependencies: string[];
dependencies: {[key: string]: string};
errorCode: string;
errorString: string;
fake: boolean | null;
formula: string;
hasError: boolean;
hasToBeComputed: boolean;
legacies: {[key: string]: string};
measure: Measure;
measureCode: string;
measureMode: string;
mmi: MeasureModeItem;
result: string;
stepDependencies: {[key: string]: number};
useLocale: boolean | null;
weight: number | null;
}

